ui.toolbar = function(){
	ui.ready(
		".toolbar",
		function(jq){
			jq.find(".contenedorColapsable").each(
				function(){
					$(this).find(".tit .i").click(
						function(ev){
							ev.preventDefault();
							$(this).closest(".contenedor").toggleClass("contenedorColapsableOn");
						}
					);
				}
			);
			
			//al ponerlo aquí, nos aseguramos que sólo se inicializa el click en body si hay toolbars
			var body = $("body"); 
			if(!body.data("tb")){
				body.click(
					function(ev){
						$(".toolbar .contenedorColapsable").not($(ev.target).closest(".contenedor")).removeClass("contenedorColapsableOn");
					}
				);
				body.data("tb",true);
			}
		}
	);
}();

